
/* eslint-disable require-jsdoc */
function markerTmpl(data) {
  const url = encodeURIComponent(data.address);

  return `<article class="marker-box">
    <div class="marker-box__wrap">
      <div class="marker-box__grid">
        <div class="marker-box__main">
          <span class="marker-box__title">${data.venueName}</span>
          <address class="marker-box__address">
            <span class="marker-box__address">${data.address}</span>
          </address>
          <div class='hearby-map-event-image'>
            <div class='hearby-map-ei'>
              <img src="${data.venueImage}" onerror="this.style.display='none'">          
            </div>
          </div>
          <a
            class="marker-box__btn btn-line"
            href="https://www.google.com/maps/place/${url}/"
            target="_blank" rel='noreferrer'>Get Directions</a>
        </div>
      </div>
    </div>
  </article>`;
}

export default markerTmpl;
